import { Component, Vue } from 'vue-property-decorator';
import { EventResponse } from '@/model/Event';

@Component
export default class EventLoaderMixin extends Vue {
    fetchEventById!: (id: number) => Promise<void | EventResponse>;

    setEvent!: (event: EventResponse | null) => void;

    getEvent!: EventResponse | null;

    loading = true;

    eventId: number = +this.$route.params.id;

    created(): void {
        this.setEvent(null);
    }

    mounted(): void {
        this.fetchEventById(this.eventId)
            .then(() => {
                document.title = `${this.getEvent?.name} - Cascade`;
            })
            .catch(() => {
                document.title = `${this.$t(
                    'event.not-found',
                ).toString()} - Cascade`;
                this.$router.push({ name: 'NotFound' });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
